import creditCardDetails from './creditCardDetails';
import creditCardList from './creditCardList';
import addCard from './addCard';

export default [creditCardDetails, creditCardList, addCard];
